import React from 'react';
import { Container, Box, Typography, Button, Grid,  Paper, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { theme } from './utils/theme'
import Section from './utils/section';


function ContactUsPage() {
    return (
        <Section title="Get In Touch">
            <Container maxWidth="md">
                <Paper elevation={3} sx={{ p: {xs: 2, sm: 4}, borderRadius: '20px', background: theme.palette.background.paper, backdropFilter: 'blur(10px)' }}>
                    <Typography variant="h6" align="center" paragraph>Have questions or want to work with us? Drop us a line!</Typography>
                    <Box component="form" noValidate autoComplete="off">
                        <Grid container spacing={3}>
                            <Grid item size={12}>
                                <TextField fullWidth label="Your Name" variant="outlined" />
                            </Grid>
                            <Grid item size={12}>
                                <TextField fullWidth label="Your Email" variant="outlined" />
                            </Grid>
                            <Grid item size={12}>
                                <TextField fullWidth multiline rows={6} label="Your Message" variant="outlined" />
                            </Grid>
                            <Grid item size={12} sx={{ textAlign: 'center' }}>
                                <Button type="submit" variant="contained" color="primary" size="large" endIcon={<SendIcon />}>
                                    Send Message
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Container>
        </Section>
    );
}

export default ContactUsPage